export const API = {
  BASE_URL: process.env.REACT_APP_API_URL,
};

export const TEMPLATES_PATHS = Object.freeze({
  GET_ALL: '/templates',
  POST: '/templates',
  GET_BY_ID: '/templates/:id',
  DELETE_BY_ID: '/templates/:id',
  DELETE_BY_IDS: '/templates/:ids',
  ARCHIVE_BY_IDS: '/templates/archive',
  DELETE_TEMPLATES: '/templates',
  CLONE: '/templates/:id/:additionalPath',
  GET_FORM_TYPES: '/templates/formtype',
  PATCH_BY_ID: '/templates/:id',
  POST_DOCUMENT: '/documents',
  BIN_UPLOAD: '/templates/uploadBinary',
  BIN_GET: '/templates/getBinary/:id',
  GET_CUSTOM_EMAIL_DATA: '/email/custom-email-data',
  SEND_CUSTOM_EMAIL: '/email/send-custom-email',
  GET_MEDIA: '/media',
  DOWNLOAD_IMAGES: '/media/download/:id',
  UPLOAD_MEDIA: '/media',
  DELETE_MEDIA: '/media/:id',
  MAIL_PREVIEW: '/templates/:templateId/render',
  ONE_SOURCE: '/sources/one/:sourceId',
  EXPORT: '/templates/export',
  IMPORT: '/templates/import',
});

export const EXTERNAL_APPLICATIONS = Object.freeze({
  GET_SOURCES_TYPES: '/dataTypes/:templateType',
});

export const AUTH_PATHS = Object.freeze({
  CHECK: '/auth/check',
  LOGIN: '/auth/login',
});
